import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { TabHistory } from "./TabHistory";
import { useAutoTab } from "@/hooks/components/useAutoTab";

interface ProtectedLayoutProps {
  isAuthenticated: boolean;
  isInitialized: boolean;
}

export function ProtectedLayout({ isAuthenticated, isInitialized }: ProtectedLayoutProps) {
  const location = useLocation();
  useAutoTab(); // 자동 탭 추가

  // 초기화 중일 때는 로딩 표시
  if (!isInitialized) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">로딩 중...</p>
        </div>
      </div>
    );
  }

  // 인증되지 않은 경우 로그인 페이지로 리다이렉트
  if (!isAuthenticated) {
    return <Navigate to={`/login?callbackUrl=${encodeURIComponent(location.pathname)}`} replace />;
  }

  return (
    <div className="h-screen bg-gray-50 flex flex-col">
      <Header />
      <TabHistory />
      <main className="flex-1 max-w-full overflow-hidden">
        <Outlet />
      </main>
    </div>
  );
}
